import React from 'react';
import PageContainer from '../components/PageContainer';
import { FiPlay } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const videos = [
  { id: 1, title: "Bitch (Official Remastered Video)", thumb: "https://images.unsplash.com/photo-1619983081563-430f63602796?q=80&w=800&auto=format&fit=crop", views: "10M+" },
  { id: 2, title: "Live at The Roxy '98", thumb: "https://images.unsplash.com/photo-1501612780327-45045538702b?q=80&w=800&auto=format&fit=crop", views: "2.5M" },
  { id: 3, title: "Studio Sessions: The Making Of", thumb: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?q=80&w=800&auto=format&fit=crop", views: "Club Exclusive" },
  { id: 4, title: "Acoustic Set - MTV Unplugged", thumb: "https://images.unsplash.com/photo-1510915361894-db8b60106cb1?q=80&w=800&auto=format&fit=crop", views: "5M" },
];

export default function Media() {
  return (
    <PageContainer title="Music & Video">
      {/* Featured Video */}
      <div className="mb-12">
        <div className="relative aspect-video bg-black rounded-xl overflow-hidden border border-gray-800 shadow-2xl group cursor-pointer">
          <img src="https://images.unsplash.com/photo-1493225457124-a1a2a5f5cb46?q=80&w=2070&auto=format&fit=crop" alt="Featured Video" className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 bg-sun-yellow rounded-full flex items-center justify-center pl-2 group-hover:scale-110 transition-transform shadow-[0_0_30px_rgba(255,215,0,0.5)]">
              <SafeIcon icon={FiPlay} className="w-10 h-10 text-black" />
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black to-transparent">
            <span className="bg-sun-yellow text-black text-xs font-bold px-2 py-1 uppercase rounded mb-2 inline-block">Featured</span>
            <h2 className="text-3xl font-display text-white">Latest Music Video Premiere</h2>
          </div>
        </div>
      </div>

      {/* Video Grid */}
      <h3 className="text-2xl font-display text-sun-yellow mb-6 border-b border-gray-800 pb-2">More Videos</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {videos.map((vid) => (
          <div key={vid.id} className="group cursor-pointer">
            <div className="relative aspect-video rounded-lg overflow-hidden mb-3 border border-gray-800">
              <img src={vid.thumb} alt={vid.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                 <SafeIcon icon={FiPlay} className="w-12 h-12 text-sun-yellow drop-shadow-lg" />
              </div>
              <div className="absolute bottom-2 right-2 bg-black/80 px-2 py-1 text-xs rounded text-sun-yellow font-bold">
                {vid.views}
              </div>
            </div>
            <h4 className="font-bold text-white group-hover:text-sun-yellow transition-colors line-clamp-2">{vid.title}</h4>
          </div>
        ))}
      </div>
    </PageContainer>
  );
}